import React, { useCallback, useEffect, useState } from 'react'
import { Button, Modal } from '@enamelai/design-system'
import { openKioskWindow } from '@utils/kioskFormsUrl.util'
import './PatientOTPModal.css'

interface PatientOTPModalProps {
  show: boolean
  onHide: () => void
  patientName: string
  otp: string
  patientId?: string
  onRegenerate: () => void
}

const formatDisplayOtp = (value: string): string =>
  value.replace(/\s/g, '').split('').join(' ')

const PatientOTPModal: React.FC<PatientOTPModalProps> = ({
  show,
  onHide,
  patientName,
  otp,
  onRegenerate,
}) => {
  const [copied, setCopied] = useState(false)
  const displayOtp = formatDisplayOtp(otp)

  useEffect(() => {
    if (!show) {
      setCopied(false)
    }
  }, [show])

  const handleCopyOTP = (): void => {
    void navigator.clipboard.writeText(otp.replace(/\s/g, ''))
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, 2000)
  }

  const handleRegenerate = (): void => {
    onRegenerate()
    setCopied(false)
  }

  const handleOpenKiosk = useCallback((): void => {
    openKioskWindow()
    onHide()
  }, [onHide])

  const name = patientName.trim() || 'Patient'

  return (
    <Modal
      open={show}
      onClose={onHide}
      size="md"
      className="patient-otp-modal"
      title="Patient OTP"
      primaryLabel=""
      secondaryLabel=""
      onPrimaryClick={onHide}
      footerStart={
        <div className="patient-otp-modal__actions">
          <Button variant="secondary" size="sm" onClick={handleCopyOTP}>
            {copied ? 'Copied!' : 'Copy OTP'}
          </Button>
          <Button variant="secondary" size="sm" onClick={handleRegenerate}>
            Regenerate OTP
          </Button>
          <Button variant="primary" size="sm" onClick={handleOpenKiosk}>
            Open Kiosk
          </Button>
          <Button variant="secondary" size="sm" onClick={onHide}>
            Close
          </Button>
        </div>
      }
    >
      <p className="patient-otp-title">{name}&apos;s OTP</p>
      <div className="patient-otp-code-container">
        <div className="patient-otp-code">{displayOtp}</div>
      </div>
    </Modal>
  )
}

export default PatientOTPModal
